import FooterCompact from "./FooterCompact";
import Sidebar from "../Sidebar";
import GameStatusIndicator from "../GameStatusIndicator";

const DashboardLayout = ({ children }) => {
  return (
    <>
      <Sidebar />
      <GameStatusIndicator />
      <main className="main-content" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1 }}>
          {children}
        </div>
        <FooterCompact />
      </main>
    </>
  );
};

export default DashboardLayout;
